import type { ReactNode } from 'react';

import type { SxProps, Theme } from '@mui/material';
import { Stack as MuiStack } from '@mui/material';

type RowProps = Readonly<{
  children: ReactNode;
  spacing?: number;
  alignItems?: 'center' | 'flex-start' | 'flex-end' | 'stretch' | 'baseline';
  justifyContent?:
    | 'center'
    | 'flex-start'
    | 'flex-end'
    | 'space-between'
    | 'space-around'
    | 'space-evenly';
  sx?: SxProps<Theme>;
  className?: string;
}>;

export const Row = ({ children, spacing, alignItems, justifyContent, sx, className }: RowProps) => (
  <MuiStack
    direction='row'
    spacing={spacing}
    alignItems={alignItems}
    justifyContent={justifyContent}
    sx={sx}
    className={className}
  >
    {children}
  </MuiStack>
);
